














































import { Component, Vue } from 'vue-property-decorator';
import { ContentCategory, IContent, INarrative, IScenario } from '../models';
import { CollectionNames, CollectionNamesArr } from '../services/meiosis';
import { CollectionsModel } from '../services/states/collection-state';

@Component({
  components: {},
})
export default class NarrativeComponentsVert extends Vue {
  private scenario?: Partial<IScenario> = {};
  private narrative: INarrative = {} as INarrative;
  private collections: CollectionsModel<IContent> | null = null;
  private categoryNames: ContentCategory[] = [];
  private categories: { [key in ContentCategory]: Array<CollectionNames> } = {} as {
    [key in ContentCategory]: Array<CollectionNames>;
  };

  constructor() {
    super();
  }

  private async init() {
    this.$store.states.map(s => {
      this.scenario = s.scenarios.current;
      this.narrative = s.app.narrative;
      this.categories =
        this.scenario && this.scenario.categories
          ? this.scenario.categories
          : ({} as { [key in ContentCategory]: Array<CollectionNames> });
      this.categoryNames = Object.keys(this.categories || []) as ContentCategory[];
      this.collections = s;
    });
  }

  private getNarrativeComponents(cat: ContentCategory) {
    const category = this.categories[cat];
    const names = CollectionNamesArr.filter(r => category.includes(r)).sort((a, b) => {
      const aIdx = category.indexOf(a);
      const bIdx = category.indexOf(b);
      return aIdx > bIdx ? 1 : -1;
    });
    return names.reduce((acc, cur) => {
      acc[cur] = this.narrative.components[cur];
      return acc;
    }, {} as Record<string, string>);
  }

  private getCollectionVal(id: string, col: CollectionNames): string {
    const list = this.collections && this.collections[col] && this.collections[col].list;
    const item: Partial<IContent> | undefined = list ? list.find(l => l.id === id) : undefined;
    return item && item.name ? item.name : '?';
  }

  private getTooltip(id: string, col: CollectionNames): string {
    const list = this.collections && this.collections[col] && this.collections[col].list;
    const item: Partial<IContent> | undefined = list ? list.find(l => l.id === id) : undefined;
    return item && item.desc ? item.desc : '';
  }

  private getCollectionNames(cat: ContentCategory): CollectionNames[] {
    return CollectionNamesArr.filter(r => this.categories[cat].includes(r));
  }

  async mounted(): Promise<void> {
    await this.init();
  }
}
